export class OpenChatListAction {
   public static readonly type = '[ChatList] Open Chat List';
}

export class CloseChatListAction {
   public static readonly type = '[ChatList] Close Chat List';
}

export class ToggleChatListAction {
   public static readonly type = '[ChatList] Toggle Chat List';
}
